import React from "react";
import Icone from "./Icone";

// Politique de mot de passe du BOA (identique à celle de l'API : 9 caractères,
// 3 minuscules, 1 majuscule, 1 chiffre).
export const REGLES = [
  { cle: "longueur", libelle: "9 caractères minimum", test: (v) => v.length >= 9 },
  { cle: "minuscules", libelle: "3 minuscules", test: (v) => v.replace(/[^a-z]/g, "").length >= 3 },
  { cle: "majuscule", libelle: "1 majuscule", test: (v) => /[A-Z]/.test(v) },
  { cle: "chiffre", libelle: "1 chiffre", test: (v) => /[0-9]/.test(v) },
];

/**
 * Évalue un mot de passe : règles respectées, conformité, niveau de la jauge
 * (0 vide, 1 à 3 selon le nombre de règles, 3 conforme, 4 conforme et ≥ 14 caractères).
 */
export function evaluerMotDePasse(valeur) {
  const v = valeur || "";
  const regles = REGLES.map((r) => ({ cle: r.cle, libelle: r.libelle, ok: r.test(v) }));
  const nbOk = regles.filter((r) => r.ok).length;
  const conforme = nbOk === REGLES.length;
  let niveau = v.length === 0 ? 0 : nbOk;
  if (conforme) niveau = v.length >= 14 ? 4 : 3;
  return { regles, nbOk, conforme, niveau };
}

const ReglesMotDePasse = ({ motDePasse }) => {
  const { regles, niveau } = evaluerMotDePasse(motDePasse);
  return (
    <>
      <div className="jauge" data-niveau={niveau} aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>
      <ul className="regles" aria-label="Règles du mot de passe">
        {regles.map((r) => (
          <li key={r.cle} className={r.ok ? "ok" : ""} data-regle={r.cle}>
            <span className="puce">
              <Icone nom="coche" epaisseur={3.5} />
            </span>
            {r.libelle}
            <span className="sr-only">{r.ok ? " : respectée" : " : à respecter"}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ReglesMotDePasse;
